<template>
	<window-view title="Publiser" v-on="$listeners" :width="800" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.topic" label="Emne" />
				</grid-view>
				<grid-view>
					<prism-editor class="my-editor" v-model="m.tmpl" :highlight="highlighter" line-numbers style="height: 600px;"></prism-editor>
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import activity from '../../../model/activity';

	

	import { highlight, languages } from 'prismjs/components/prism-core';
	import 'prismjs/components/prism-json';
	//import 'prismjs/themes/prism-tomorrow.css';
	import 'prism-themes/themes/prism-ghcolors.css';

	

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				m: {
					id: '',
					topic: '',
					tmpl: ''
				}
			};
		},
		computed: {
			_timestamp() {
				try {
					const json = JSON.parse(this.m.payload);
					return json.hasOwnProperty('timestamp') ? this.$options.filters.unix_timestamp_s(json.timestamp) : '';
				} catch (e) {
					return '';
				}
			},
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Publiser',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		methods: {
			highlighter(code) {
				return highlight(code, languages.json); //returns html
			}
		},
		mounted() {
			try {
				const json = JSON.parse(this.m.payload);
				this.m.payload = JSON.stringify(json, null, 4);
			} catch (e) {
				//
			}
		},
		async created() {
			console.log('languages', languages);
			console.log('m', this.model);
			//this.m = {...this.m, ...this.model};

			this.m.id = this.model.id;
			this.m.topic = this.model.topic;

			console.log('tmpl', this.model.tmpl);
			
			this.m.tmpl = JSON.stringify(this.model.tmpl, null, 4).replaceAll('%timestamp', Date.now());
		}
	}
</script>

<style lang="scss" scoped>
	/* required class */
	.my-editor {

		background: #f5f5f5;
		color: #ccc;

		font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
	}

	/* optional class for removing the outline */
	.prism-editor__textarea:focus {
		outline: none;
	}
</style>